export const USER_ACCESS_PERMISSIONS = {
  manageApp: 'manageApp',
  manageUsers: 'manageUsers',
}
